import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { InfoDot } from '@mdvip/shared/components/blocks/InfoDot';
import { useTranslation } from 'react-i18next';
import { formatCardNumber, formatExpiry } from '@/lib/payments/paymentAccount.format';
import { AutoPayCheckbox, HsaRadioField, MakeDefaultCheckbox, TextField } from './fields';

const formatCvv = (value: string) => value.replace(/\D/g, '').slice(0, 4);

export function CreditCardFields({
  autoPayEnrolled,
  fromAutopay,
}: {
  autoPayEnrolled: boolean;
  fromAutopay?: boolean;
}) {
  const { t } = useTranslation('members');

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-foreground">{t('payments.addAccount.cardSection')}</span>
          <span className="inline-flex items-center gap-1 text-xs font-medium text-success">
            <Icon name="lock" weight="solid" size="xs" /> {t('payments.addAccount.secured')}
          </span>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,2fr)_minmax(0,1.4fr)_minmax(0,1fr)]">
          <TextField
            name="card.cardNumber"
            label={t('payments.addAccount.cardNumber')}
            inputMode="numeric"
            sensitive
            format={formatCardNumber}
          />
          <TextField
            name="card.expiry"
            label={t('payments.addAccount.expiry')}
            inputMode="numeric"
            format={formatExpiry}
          />
          <TextField
            name="card.cvv"
            label={t('payments.addAccount.cvv')}
            info={t('payments.addAccount.cvvInfo')}
            inputMode="numeric"
            sensitive
            format={formatCvv}
          />
        </div>
      </div>
      <div className="space-y-2.5">
        <HsaRadioField scope="card" />
        <div className="flex items-center gap-1 text-sm font-medium text-muted-foreground">
          {t('payments.addAccount.fsa')}
          <InfoDot text={t('payments.addAccount.fsaInfo')} />
        </div>
      </div>
      <div className="space-y-2.5">
        <MakeDefaultCheckbox scope="card" />
        <AutoPayCheckbox scope="card" autoPayEnrolled={autoPayEnrolled} fromAutopay={fromAutopay} />
      </div>
    </div>
  );
}
